<template>
  <staff-set class="content"></staff-set>
</template>

<script>
    import StaffSet from "./create/StaffSet";
    export default {
        name: "ActivityStaff",
        components: {
            StaffSet
        },
    }
</script>

<style scoped lang="less">
</style>
